import { useContext, useState } from "react";

import { SelectKVPControl } from "@/Common/Components/Inputs/SelectKVPControl";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";
import { LinkButton } from "@/DesignSystem";
import { CareComponentConfigurationContext, ICareComponentConfigurationContext } from "@/Flowsheets/Models/CareComponentConfigurationContext";
import { CareElementsConfiguration } from "./CareElementsConfiguration";

import styles from "./CareComponentConfiguration.module.scss";

function CareComponentConfiguration(props: Readonly<ICareComponentConfigurationContext>): JSX.Element {
    return (
        <CareComponentConfigurationContext.Provider value={props}>
            <CareComponentConfigurationWithContext />
        </CareComponentConfigurationContext.Provider>
    );
}

function CareComponentConfigurationWithContext(): JSX.Element {
    const { getText } = useTranslation();
    const [showAddElement, setShowAddElement] = useState(false);

    const { careComponentName, availableElements, onAdd } = useContext(CareComponentConfigurationContext);

    return (
        <div className={styles.careComponentConfigurationContainer}>
            <CareElementsConfiguration />
            {availableElements.length > 0 && (
                <div className={styles.addCareElementContainer}>
                    {showAddElement ? (
                        <SelectKVPControl
                            AvailableValues={availableElements.map(el =>
                                (new KeyValuePair(el.Name, getText(`Flowsheets_${careComponentName}Label_${el.Name}`)))
                            )}
                            Callback={key => {
                                if (key) {
                                    onAdd(key);
                                    setShowAddElement(false);
                                }
                            }}
                            Value=""
                            Placeholder={getText("Flowsheets_SelectCareElementPlaceholderLabel")}
                        />
                    ) : (
                        <LinkButton
                            label={getText("Flowsheets_AddCareElementLabel")}
                            onClick={() => setShowAddElement(true)}
                        />
                    )
                    }
                </div>
            )}
        </div>
    );
}

export { CareComponentConfiguration };
